export const generateExportRequest = ({ columns, items, includeComments }: any) => {
  const fields = columns.map((column: { name: string; title: string }) => ({
    id: column.name,
    title: column.title,
  }));

  return {
    format: 'excel',
    item_ids: items,
    fields: fields,
    include_comments: includeComments,
  };
};
